export const state = {
	toggle: true
};

export const mutations = {
  changeToggle() {
    state.toggle = !state.toggle;
  }
};

export const getters = {
  toggle: state => {
    return state.toggle;
  }
};

export const actions = {
  updateMenuStatus({ commit }) {
    return new Promise((resolve, reject) => {
      commit("changeToggle");
    });
  }
};
